import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const Booking = Loadable(lazy(() => import('views/pages/public/Booking')));

// ==============================|| PUBLIC ROUTING ||============================== //

const PublicRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/reservas/:slug',
            element: <Booking />
        }
    ]
};

export default PublicRoutes;
